// components/Sidebar.js
import React from 'react';
import InstallAppMenuItem from '../components/InstallAppMenuItem';

function Sidebar({ p_roles, onClose, onLogout }) {
  console.log("Sidebar roles:", p_roles);
  return (
    <div className="ui-overlay" onClick={onClose}>
      <div className="kdo-sidebar">
        <button className="kdo-sidebar-close" onClick={onClose}>×</button>
        <h3>Menu</h3>
        <InstallAppMenuItem />
        {/* <p>
          <a href="/preferences">Preferences</a>
        </p> */}
        <p>
          <a href="https://listaki.fr/aide" target="_blank" rel="noopener noreferrer">Aide</a>
        </p>
        <p>
          <a href="https://listaki.fr/changelog" target="_blank" rel="noopener noreferrer">Nouveautés</a>
        </p>
        <p>----</p>
        <p>
          <button onClick={onLogout} className="kdo-button-like-link">
            Se déconnecter
          </button>
        </p>
                {p_roles && p_roles.includes('ADMIN') && (
          <>
          <p>--ADMIN--</p>
          <p>
            <a href="/stats">Statistiques</a>
          </p>
          <p>
            <a href="/report">Rapport détaillé</a>
          </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
